import { Injectable } from '@angular/core';
import { StorageConstants } from '../constants/storage.constants';

/**
 * Provides a stable, app-generated device identifier for this browser.
 *
 * The device id is a random GUID persisted in localStorage. It is NON-SECRET
 * and used only for audit/display (the "device" a session was created from).
 * It is sent as the X-Device-Id header on auth requests.
 */
@Injectable({ providedIn: 'root' })
export class DeviceService {
  /** Returns the current device id, generating and persisting one if absent. */
  getDeviceId(): string {
    let id = localStorage.getItem(StorageConstants.DEVICE_ID_KEY);
    if (!id) {
      id = this.generateGuid();
      localStorage.setItem(StorageConstants.DEVICE_ID_KEY, id);
    }
    return id;
  }

  private generateGuid(): string {
    // Prefer the native crypto API; fall back to a Math.random GUID.
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
      return (crypto as Crypto).randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
